<style src="./Form.scss" lang="scss"></style>

<template lang="pug">
  component(
    v-if='component'
    :is='component'
    :data='data'
  )
</template>
<script>
import dinamicComponentMixin from "@/mixins/shared/dinamicComponent.mixin";

import loginTemplate from "./templates/login";
import newplaylistTemplate from "./templates/newplaylist";
import forgotPasswordTemplate from "./templates/forgotPassword";
import resetPasswordTemplate from "./templates/resetPassword";
import registerTemplate from "./templates/register";
import complainTemplate from "./templates/complain";

export default {
  props: {
    data: Object
  },
  data() {
    return {
      templates: {
        login: loginTemplate,
        newplaylist: newplaylistTemplate,
        forgotPassword: forgotPasswordTemplate,
        resetPassword: resetPasswordTemplate,
        register: registerTemplate,
        complain: complainTemplate
      }
    };
  },
  mixins: [dinamicComponentMixin]
};
</script>
